import { render, staticRenderFns } from "./MajorShareholdersDetailsUs.vue?vue&type=template&id=6c540391"
import script from "./MajorShareholdersDetailsUs.vue?vue&type=script&lang=js"
export * from "./MajorShareholdersDetailsUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports